import { useCallback } from 'react'
import { getAction } from 'businesslayer/networkrequests/actions/actions'
import { Details } from 'Types'
import { isUnlinkedAction } from 'common/util/unlinkedActions'
import { extractUTMParams, logActionDeepLinkAccess } from 'common/util/utmUtils'
interface UseActionDeepLinkOptions {
    setSelectedAction: (action: Details | null) => void
    setIsOpen: (open: boolean) => void
    onSuccess?: (action: Details) => void
    onError?: (error: any) => void
}

export const useActionDeepLink = (options: UseActionDeepLinkOptions) => {
    const { setSelectedAction, setIsOpen, onSuccess, onError } = options

    const handleDeepLink = useCallback(
        async (params: Details | any) => {
            if (params?.id) {
                try {
                    const utmParams = extractUTMParams()
                    if (utmParams.utm_source) {
                        logActionDeepLinkAccess('deep_link_access', params.id)
                    }
                    const response = await getAction(params.id)
                    if (response?.data) {
                        const actionData = response.data
                        const formattedAction = {
                            id: actionData.id,
                            text: actionData.attributes.text,
                            minutesId: actionData.attributes.minutes_document_id,
                            action_title: actionData.attributes.text,
                            assigned_to: actionData.attributes.assignees
                                ?.map((assign) => assign.text)
                                .join(', '),
                            minutesSectionId: actionData.attributes.minutes_section_id,
                            sections: [
                                {
                                    id: actionData.attributes.minutes_section_id?.toString?.(),
                                    name: actionData.attributes.section_name,
                                    sectionType: 'minutes'
                                }
                            ],
                            notes: actionData.attributes.note,
                            status: actionData.attributes.status,
                            completionStatus: actionData.attributes.completion_status,
                            notificationStatus: actionData.attributes.notification_status,
                            due_date: actionData.attributes.due_date,
                            assignees: actionData.attributes.assignees,
                            minutes_document_id: actionData.attributes.minutes_document_id,
                            minutes_section_id: actionData.attributes.minutes_section_id,
                            section_name: actionData.attributes.section_name,
                            note: actionData.attributes.note,
                            committee_id: actionData.attributes.committee_id,
                            action_completed: actionData.attributes.action_completed,
                            completion_status: actionData.attributes.completion_status,
                            remember_reminder_settings:
                                actionData.attributes.remember_reminder_settings || false,
                            reminders: actionData.attributes.reminders || [],
                            author_id: actionData.attributes.author_id,
                            from_deleted_committee: isUnlinkedAction(actionData.attributes)
                        }

                        const typedAction = (formattedAction as unknown) as Details
                        setSelectedAction(typedAction)
                        setIsOpen(true)

                        // Call optional success callback
                        onSuccess?.(typedAction)
                    }
                } catch (error) {
                    console.error('Error fetching action:', error)
                    onError?.(error)
                }
            }
        },
        [setSelectedAction, setIsOpen, onSuccess, onError]
    )

    return { handleDeepLink }
}
